export const generateVCard = (card) => {
  const fullName = [card.firstName, card.lastName].filter(Boolean).join(' ');
  const lines = [
    'BEGIN:VCARD',
    'VERSION:3.0',
    `FN:${fullName}`,
    `N:${card.lastName || ''};${card.firstName || ''};;;`,
  ];

  // Add organization if available
  if (card.company || card.role) {
    lines.push(`ORG:${card.company || ''}`);
    lines.push(`TITLE:${card.role || ''}`);
  }

  // Add email
  if (card.email) {
    lines.push(`EMAIL;type=WORK:${card.email}`);
  }

  // Add phone
  if (card.phone) {
    lines.push(`TEL;type=WORK:${card.phone}`);
  }

  // Add notes
  const notes = [];
  if (card.spouse) notes.push(`Spouse: ${card.spouse}`);
  if (card.children) notes.push(`Children: ${card.children}`);
  if (card.info) notes.push(card.info);
  if (notes.length > 0) {
    lines.push(`NOTE:${notes.join('\\n')}`);
  }

  // Add LinkedIn
  if (card.linkedIn) {
    lines.push(`URL;type=WORK:${card.linkedIn}`);
  }

  lines.push('END:VCARD');
  return lines.join('\r\n');
};

export const downloadVCard = (card) => {
  const vcard = generateVCard(card);
  const blob = new Blob([vcard], { type: 'text/vcard' });
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement('a');
  const fullName = [card.firstName, card.lastName].filter(Boolean).join('_') || 'contact';
  
  link.href = url;
  link.setAttribute('download', `${fullName}.vcf`);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
}; 